import { render, staticRenderFns } from "./LeadChangeConfirmation.vue?vue&type=template&id=c024af5e&scoped=true"
import script from "./LeadChangeConfirmation.vue?vue&type=script&lang=js"
export * from "./LeadChangeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./LeadChangeConfirmation.vue?vue&type=style&index=0&id=c024af5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c024af5e",
  null
  
)

export default component.exports